// Import model
import { FilterExternalLinkRequest } from '../models/FilterExternalLinkRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ExternalLinkCondition } from '../models/ExternalLinkCondition';
import { ExternalLinkFields } from '../models/ExternalLinkFields';
import { ExternalLinkIndexedFields } from '../models/ExternalLinkIndexedFields';

// Import dependency serializers (for complex types)
import { ExternalLinkConditionSerializer } from './ExternalLinkConditionSerializer';
import { ExternalLinkFieldsSerializer } from './ExternalLinkFieldsSerializer';
import { ExternalLinkIndexedFieldsSerializer } from './ExternalLinkIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterExternalLinkRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterExternalLinkRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterExternalLinkRequest instance
   */
  static deserialize(json: string): FilterExternalLinkRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterExternalLinkRequest instance
   */
  static fromObject(obj: any): FilterExternalLinkRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterExternalLinkRequest');
    }


    const instance: FilterExternalLinkRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ExternalLinkIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ExternalLinkFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ExternalLinkConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterExternalLinkRequest instances
   */
  static deserializeArray(json: string): FilterExternalLinkRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterExternalLinkRequest instance to a JSON string
   */
  static serialize(instance: FilterExternalLinkRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterExternalLinkRequest instance to a plain object
   */
  static toObject(instance: FilterExternalLinkRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ExternalLinkConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterExternalLinkRequest instances to a JSON string
   */
  static serializeArray(instances: FilterExternalLinkRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
